import { By } from 'selenium-webdriver';
import { DriverLike, register } from '@oracle/oraclejet-webdriver';
import { TableWebElement } from './TableWebElement';
export { TableWebElement };

/**
 * Retrieve an instance of [TableWebElement](../classes/TableWebElement.html).
 * @example
 * ```javascript
 * import { findTable } from '@oracle/oraclejet-core-pack/webdriver';
 * const el = await findTable(driver, By.id('my-oj-c-table'));
 * ```
 * @param driver A WebDriver/WebElement instance from where the element will be
 * searched. If WebDriver is passed, the element will be searched globally in the
 * document. If WebElement is passed, the search will be relative to this element.
 * @param by The locator with which to find the element
 */
export async function findTable(driver: DriverLike, by: By): Promise<TableWebElement> {
  const webEl = await driver.findElement(by);
  // Check that the element is of type TableWebElement
  if (!(webEl instanceof TableWebElement)) {
    const tagName = await webEl.getTagName();
    let supplemental = '';
    if (webEl.constructor.name === 'TableWebElement') {
      supplemental = 'You likely have multiple installations of this package.';
    }
    throw Error(
      `findTable(${by}) created ${webEl.constructor.name} for <${tagName}>, but expected ${TableWebElement.name}. ${supplemental}`
    );
  }
  return webEl;
}

register('oj-c-table', TableWebElement);
